import { useFormContext } from 'react-hook-form';
import { ICreateUserAccountFormData } from '../types/ICreateUserAccountFormData';

export function useCreateUserAccountFormContext() {
	return useFormContext<ICreateUserAccountFormData>();
}
